export default __webpack_public_path__ + "static/style4.6_Elena-4228f994abe4c9670b13f214a7afb600.wav";